import { Component } from 'react'
import forgotPasswordImg from '../../../../assets/images/forgot_password.png'
import checkImg from '../../../../assets/images/check.png'
import { Link } from 'react-router-dom'
import { Input } from '../../../components/input'
import { ErrorMessage, errorsLength, formatErrors, validateEmail } from '../../../../insfrastructure/utils/form-validators'
import { SubmitBtn } from '../../../components/submit'
import ResponseModal from '../../../components/response-modal'
import { requestOTP } from '../../../../insfrastructure/services/auth'
import { handleResendVerificationEmail } from '../../../../insfrastructure/utils/email-verification-helpers'
import { handleEmailNotValidatedError } from '../../../../insfrastructure/utils/email-not-validated-handler'
import { analytics } from '../../../../insfrastructure/services/analytics'
import './styles.sass'


interface ResponseData {
    type: 'success' | 'error';
    title: string;
    text: () => JSX.Element;
}

export default class ForgotPassword extends Component<any> {
    state: any = {
        form: {
            email: ''
        },
        formErrors: {},
        loading: false,
        sended: false,
        responseData: null as ResponseData | null,
        resendingEmail: false
    }

    componentDidMount(): void {
    }

    handleResendVerificationEmail = async () => {
        // Prevenir múltiplos cliques
        if (this.state.resendingEmail) {
            return;
        }

        await handleResendVerificationEmail({
            email: this.state.form.email,
            setResendingEmail: (value) => this.setState({ resendingEmail: value }),
            setResponseData: (data) => this.setState({ responseData: data }),
            invalidEmailMessage: 'Por favor, informe um email válido no campo acima.'
        });
    }

    onSubmit = async () => {
        this.setState({ formErrors: {}, responseData: null });
        const errors = formatErrors({
            email: [validateEmail(this.state.form.email)]
        });

        if(errorsLength(errors) > 0) {
            this.setState({ formErrors: errors });
            return;
        }

        this.setState({ loading: true });

        // Rastrear tentativa de recuperação de senha
        analytics.trackFormSubmission('forgot_password');

        try {
            await requestOTP({ email: this.state.form.email });
            
            analytics.addBreadcrumb('OTP requested successfully for password reset', 'auth', 'info');
            
            this.setState({ sended: true, loading: false });
            this.props.navigate('/reset-password', {
                state: this.state.form,
            });
        } catch (error: any) {
            analytics.trackError(error, 'forgot_password_failed');
            
            let errorMessage = 'Erro ao solicitar código de verificação. Tente novamente.';
            let errorTitle = 'Erro ao Solicitar Código';
            let errorTextComponent: (() => JSX.Element) | null = null;
            
            // Verificar se é erro de email não validado usando handler reutilizável
            const emailNotValidatedResult = handleEmailNotValidatedError({
                error,
                resendingEmail: this.state.resendingEmail,
                onResend: () => this.handleResendVerificationEmail(),
                defaultMessage: 'Por favor, confirme seu email antes de recuperar sua senha.',
                context: 'forgot_password',
                allowedStatusCodes: [403]
            });
            
            if (emailNotValidatedResult.isEmailNotValidated) {
                errorTitle = emailNotValidatedResult.errorTitle;
                errorTextComponent = emailNotValidatedResult.errorTextComponent;
            }
            // Verificar se é um erro de Axios
            else if (error.response) {
                analytics.addBreadcrumb(`Forgot password error - HTTP ${error.response.status}`, 'auth', 'error');
                
                if (error.response.status === 404) {
                    errorMessage = error.response.data?.message || 'Não encontramos uma conta com este e-mail. Verifique se digitou corretamente.';
                } else if (error.response.status === 400) {
                    errorMessage = 'Dados inválidos. Verifique o formato do email.';
                } else if (error.response.status === 403) {
                    // Status 403 mas não foi detectado como email não validado - pode ser outro tipo de erro
                    errorMessage = error.response.data?.message || 'Acesso negado. Verifique suas credenciais.';
                } else if (error.response.status >= 500) {
                    errorMessage = 'Erro interno do servidor. Tente novamente em alguns minutos.';
                } else {
                    errorMessage = error.response.data?.message || `Erro do servidor (${error.response.status}). Tente novamente.`;
                }
            } else if (error.request) {
                analytics.addBreadcrumb('Forgot password error - network failure', 'auth', 'error');
                errorMessage = 'Erro de conexão. Verifique sua internet e tente novamente.';
            } else if (error.message) {
                analytics.addBreadcrumb('Forgot password error - unexpected', 'auth', 'error');
                errorMessage = error.message;
            }
            
            const responseData: ResponseData = {
                type: 'error',
                title: errorTitle,
                text: errorTextComponent || (() => <p>{errorMessage}</p>)
            };
        
            this.setState({ loading: false, responseData });
        }
    }

    render() {
        return (
            <div className='forgot-password unlogged-page'>
                <div className='content'>
                    <div className='block'>
                        {window.innerWidth > 1000 &&
                        <div className='img-container'>
                            <img src={forgotPasswordImg} alt='forgot-password-image' />
                        </div>}
                        {
                            !this.state.sended ?
                            <div className='block-content not-sended'>
                                <div className='text'>
                                    <h1>Esqueceu a Senha?</h1>
                                    <h2>Insira seu e-mail cadastrado</h2>
                                </div>
                                <div className='form'>
                                    <Input
                                    name='email'
                                    label='Email'
                                    placeholder='Insira seu email'
                                    onChange={e => this.setState({ form: {...this.state.form, email: e} })}/>
                                    <ErrorMessage errors={this.state.formErrors['email']} />
                                </div>
                                <p className='bottom-text'>Ao <b>confirmar</b>, enviaremos um e-mail com instruções de como <b>redefinir sua senha</b>.</p>
                                <SubmitBtn className='secondary' text='Confirmar' loadingText='Enviando...' loading={this.state.loading} onSubmit={this.onSubmit} />
                            </div> :
                            <div className='block-content sended'>
                                <div className='text'>
                                    <img className='check' src={checkImg} alt='check-image' />
                                    <h3>E-mail de redefinição de senha enviado</h3>
                                </div>
                                <p className='bottom-text'>Um e-mail foi enviado para seu endereço de e-mail a <b>{this.state.form.email}</b>. Siga as instruções para redefinir sua senha.</p>
                                <Link to='/login'><SubmitBtn className='secondary' text='OK' /></Link>
                            </div>
                        }
                    </div>
                </div>
                {this.state.responseData && (
                    <ResponseModal
                    render={true}
                    type={this.state.responseData.type}
                    title={this.state.responseData.title}
                    text={this.state.responseData.text}
                    onClose={() => this.setState({ responseData: null })} />
                )}
            </div>
        )
    }
}